/**
 * LoginBanner - Banner displayed when the user is not authenticated
 * Invites the user to sign in via centralized auth
 */
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './LoginBanner.css';

const LoginBanner = () => {
  const { currentUser, redirectToAuth } = useAuth();

  if (currentUser) return null;

  const handleLoginClick = () => {
    redirectToAuth('login');
  };

  return (
    <div className="login-banner">
      <button className="login-banner-btn" onClick={handleLoginClick}>
        <i className="bi bi-box-arrow-in-right me-1"></i>
        Se connecter
      </button>
    </div>
  );
};

export default LoginBanner;
